export default "__VITE_ASSET__DMMX7zqN__"